import { Box } from '@mui/material';
import type { FieldElement } from '../../format/form-definition';
import { FieldFrame } from '../../rendering/FormElements';
import { fieldInputOf } from '../../rendering/fieldInput';
import { holdsFields, optionsOf } from '../../format/elements';
import type { ReactNode } from 'react';
import { useBuilder } from '../context';
import { fieldPreview } from '../fieldPreview';

export const UNTITLED = {
  field: 'Untitled field',
  group: 'Untitled group',
  section: 'Untitled section',
  text: 'Empty text',
} as const;

export const CanvasField = ({ field, children }: { field: FieldElement; children?: ReactNode }) => {
  const { form } = useBuilder();
  const preview = fieldPreview(form, field);
  const { settings, Input, labelKind, emptyValue } = fieldInputOf(field);
  const untitled = field.label.trim() === '';
  const group = holdsFields(field);
  const inputLabel = untitled ? (group ? UNTITLED.group : UNTITLED.field) : field.label;
  const label = untitled ? (
    <Box component="span" sx={{ color: 'text.disabled' }}>
      {inputLabel}
    </Box>
  ) : (
    inputLabel
  );
  return (
    <Box sx={{ pointerEvents: group ? undefined : 'none' }}>
      <FieldFrame label={label} required={preview.required} labelKind={labelKind} description={field.description}>
        {ids => (
          <Input
            {...ids}
            settings={settings}
            options={optionsOf(field)}
            label={inputLabel}
            showLabel={labelKind === 'outlined'}
            value={group ? [{}] : (field.defaultValue ?? emptyValue)}
            rows={group ? { render: () => children } : undefined}
            onChange={() => {}}
            onBlur={() => {}}
            disabled
            error={false}
            required={preview.required}
            bounds={preview.bounds}
            attachFile={() => {
              throw new Error('The Builder attaches no files.');
            }}
          />
        )}
      </FieldFrame>
    </Box>
  );
};
